import { Component, Vue, Watch } from 'vue-property-decorator';
import { TableDataSet } from '@/models/tableDataset/TableDataSet';
import { DataSetStore } from '@/store/store.dataSet';

import SettingsReport from '@/components/settingsreport/SettingsReport.vue';
import { EventStore } from '@/store/store.event';
import { DataSetService, SynchronizationService } from '@/services/index';
import { UserProfileStore } from '@/store/store.userProfile';
import { DataSetEventTypeEnums } from '@/enums/DataSetEventTypeEnums';
import { DataSetEditor } from '@/models/dataset/DataSetEditor';
import { DataSet } from '@/models/dataset/DataSet';
import { AppSettingsService } from '@/services/index';


@Component({
    components: {
        SettingsReport,
    },
})
export default class SettingsReportViewComponent extends Vue {
    public data?: TableDataSet;
    public dataSetId: string = '';
    public unsyncedEventId: number = -1;
    public showLoader: boolean = true;
    public emptyOnly: boolean = false;

    private quickEdit: boolean = false;

    // tslint:disable-next-line: no-empty
    public mounted() {
        this.dataSetId = this.$route.params.dataSetId || '';
        this.unsyncedEventId = parseInt(this.$route.params.unsyncedEventId, 10) || -1;
        this.emptyOnly = this.$route.params.empty && this.$route.params.empty === 'true' || false;
        this.quickEdit = this.$route.params.quickEdit && this.$route.params.quickEdit === 'true' || false;
    }

    @Watch('dataSetId')
    public onSyncedDataSetIdChanged(newValue: string) {
        this.showLoader = true;
        if (newValue !== '') {
            const dataSet = DataSetService.GetAllDataSets().find((tds) => tds.dataSetId === this.dataSetId);
            this.data = DataSetService.GenerateTableDataSet(dataSet || new DataSet());
            this.showLoader = false;
        }
    }

    @Watch('unsyncedEventId')
    public onUnsyncedEventIdChanged(newValue: number) {
        this.showLoader = true;
        const event = EventStore.GetUnsyncedEvents.find((e) => e.id === newValue);
        if (event !== undefined) {
            this.data = DataSetService.GenerateTableDataSet(event.dataSet as DataSet);
            if (this.data.created.date === undefined || this.data.created.date === '') {
                this.data.created.date = (new Date()).toISOString();
            }
            if (this.data.created.userName === undefined || this.data.created.userName === 'unknown') {
                this.data.created.userName = UserProfileStore.GetUserProfile.userName || 'unknown';
            }
            if (event.event === DataSetEventTypeEnums.UPDATE && this.data.lastModified === undefined) {
                this.data.lastModified = new DataSetEditor({
                    date: (new Date()).toISOString(),
                    userName: UserProfileStore.GetUserProfile.userName || 'unknown',
                    userEmail: UserProfileStore.GetUserProfile.userEmail || 'unknown',
                    userId: '',
                });
            }
        }
        this.showLoader = false;
    }

    public print() {
        window.print();
    }

    public async back() {
        if (this.unsyncedEventId >= 0 && SynchronizationService.IsRunnung() === true) {
            /**
             * if called from the edit view we used an unsynced event and
             * now need to check if sync is needed.
             */
            this.showLoader = true;
            await SynchronizationService.SyncNow()
                .finally(() => {
                    this.showLoader = false;
                });
        }
        if (this.quickEdit === true) {
            AppSettingsService.SetNavigateTo = 'table';
        }
        this.$router.back();
    }
}
